import CostContainerSale from './CostContainerSale'

export default CostContainerSale
